/*
 * Project: xpenser-client
 * FilePath: /src/app/pages/Home/index.tsx
 * File: index.tsx
 * Created Date: Friday, September 18th 2020, 6:42:54 pm
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Sat Sep 19 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 * <<licensetext>>
 */

import React from 'react'
import { Link } from 'react-router-dom'

import Template, { Layouts } from '@pages/template'

export default function HomePage () {
  const type: Layouts = 'blank'

  return (
    <Template
      type={type}
      content={() => (<p>Home page: <Link to="/login">Login</Link></p>)}
    />
  )
}
